import './JiraIssueMappingTooltip.scss';
import { createAsyncSelectors } from '@lib/selectors';
import { Link } from 'react-router-dom';
import React from 'react';
import { SonarText } from '@ui/text';
import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { Else, If, Then } from 'react-if';

export const jiraSyncSelector = createAsyncSelectors((state) => state.integrations.jira.initiatives.sync.post);

export interface JiraIssueMappingTooltipProps {
	missingMapping?: boolean;
}

export const JiraIssueMappingTooltip: React.FC<JiraIssueMappingTooltipProps> = ({ missingMapping }) =>
	<SonarText className='jira-issue-status-warning'>
		<If condition={ missingMapping }>
			<Then>{ COPY_SPECIFIC.JIRA_UNMAPPED_STATUS }</Then>
			<Else>{ COPY_SPECIFIC.JIRA_INCOMPLETE_STATUS }</Else>
		</If>
		<Link to={ `${FULL_ROUTES.SETTINGS_JIRA}` }>{ COPY_SPECIFIC.GO_TO_SETTINGS }</Link>
		{ COPY_SPECIFIC.JIRA_SET_UP_MAPPING }
	</SonarText>;

